import LinearProgress from '@mui/material/LinearProgress';

import "../CSS/components/Progressbar.css";

interface LinearProgressWithLabelProps {
  progress: number; // Percentage
  progressMessage: string;
  isFailed: boolean;
}
export const LinearProgressWithLabel = ({ progress, progressMessage, isFailed=false}: LinearProgressWithLabelProps) => {

  return (
    <div className="ProgressBarWithLabel">
      <div className="ProgressBar">
        <LinearProgress variant="determinate" value={progress} sx={{ flex: 1, marginRight: '10px',
          '& .MuiLinearProgress-bar': {
                    backgroundColor: !isFailed ? 'var(--naturGreen)' : 'var(--red-button)'
                  },
          backgroundColor: 'var(--primary-colorSwitched)'}}/>
        <span>{`${Math.round(progress)}%`}</span>
      </div>
      <div className="ProgressMessage">{progressMessage}</div>
    </div>
  );
}